import PropTypes from "prop-types";
import Button from "@shared/v2/Button";
import Modal from "@shared/v2/Modal";

const DeleteModal = ({ deleteTasksHandler, showDeleteModal, closeDeleteModal, submitDisabled, type }) => (
  <Modal
    show={showDeleteModal}
    onHide={closeDeleteModal}
    dialogClassName="tw-flex tw-items-center tw-justify-center tw-h-full"
    contentClassName="tw-max-w-[440px] tw-max-h-[90vh] tw-w-full tw-flex tw-flex-col tw-gap-[32px]"
  >
    <Modal.Header title={`Delete ${type}`} closeButton />
    <Modal.Body>
      <div>
        <div>
          Are you sure you want to delete {type === "Tasks" ? "the selected" : "this"}{" "}
          <span className="tw-lowercase"> {type}</span>? This action cannot be undone.{" "}
        </div>
        <div className="tw-pt-[20px]">
          <span className="tw-font-bold">
            {type === "Appointment" || type === "Tasks" ? "Important:" : "Note:"}
          </span>{" "}
          {type === "Tasks"
            ? "If you have selected any appointments to be deleted, people who have access to view them will not see that they were deleted. Deleted appointments will no longer be tracked in any reporting pages such as Leaderboards, Agent Dashboard, and more."
            : `People who have access to view this ${type.toLowerCase()} will not see that
          it was deleted.
          ${
            type === "Appointment"
              ? " Also, deleted appointments will no longer be tracked in any reporting pages such as Leaderboards, Agent Dashboard, and more."
              : ""
          }`}
        </div>
      </div>
    </Modal.Body>
    <Modal.Footer className="tw-flex tw-justify-between tw-gap-[8px]">
      <Button
        size="medium"
        schema="tertiary"
        className="modal-cancel tw-float-left"
        onClick={closeDeleteModal}
      >
        Cancel
      </Button>
      <Button size="medium" schema="warning" onClick={deleteTasksHandler} isLoading={submitDisabled}>
        Yes, Delete
      </Button>
    </Modal.Footer>
  </Modal>
);

DeleteModal.propTypes = {
  showDeleteModal: PropTypes.bool,
  deleteTasksHandler: PropTypes.func,
  closeDeleteModal: PropTypes.func,
  submitDisabled: PropTypes.bool,
  type: PropTypes.string,
};

DeleteModal.defaultProps = {
  showDeleteModal: false,
  deleteTasksHandler: null,
  closeDeleteModal: null,
  submitDisabled: false,
  type: "Appointment",
};
export default DeleteModal;
